export default "__VITE_ASSET__B25Oscde__"